import { render, staticRenderFns } from "./OrdersByProduct.vue?vue&type=template&id=7b696cf0&"
import script from "./OrdersByProduct.vue?vue&type=script&lang=js&"
export * from "./OrdersByProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports